import { render, staticRenderFns } from "./UpdateAttributes.vue?vue&type=template&id=2f1ca316&"
import script from "./UpdateAttributes.vue?vue&type=script&lang=js&"
export * from "./UpdateAttributes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports